import React, {useEffect, useRef} from 'react';

import {WebsiteModuleProps} from "../models/website-module.props";
import {Router} from "../../../core/components/router/router";
import {WebsiteModulePageMetaData} from "./website-module.page-meta-data";
import {observer} from "mobx-react";
import styles from "../styles/website.module.scss";
import classNames from "classnames";
import {WEBSITE_MODULE} from "../website-module.consts";
import {ScrollerWrapper} from "../../../core/components/scroll-wrapper/scroll-wrapper";

export class WebsiteContentProps extends WebsiteModuleProps {
}

export const WebsiteModuleContent = observer(({controller}: WebsiteContentProps) => {
  const ref = useRef(null);
  const {state: {contextGameId, isStickyContent, displaySettings, isAllScores, currentLinkModel}, device} = controller;
  const {isSmallView} = device;

  const scrollToTop = () => {
    if (ref?.current) {
      ref.current.scrollTop = 0;
    }
  }

  useEffect(() => {
    scrollToTop();
  }, [contextGameId, currentLinkModel?.params?.matchDetails, currentLinkModel?.hashParams?.id]);

  const routerProps = {
    onChange: (route) => controller.action(WEBSITE_MODULE.ACTION_TYPES.onRouteChange, {route}),
    scrollToTop
  };

  const className = classNames(
    styles.main_content,
    {[styles.sticky_main_content]: isStickyContent},
    {[styles.is_homepage]: isAllScores},
    {[styles.scores_and_athletes]: !displaySettings.isNewEntitiesPages && !isSmallView},
    {[styles.no_bars_main_content]: displaySettings.noBarsVisible})

  const contentProps = {
    className,
    ref,
    wheelPropagation: true
  }

  return (
    displaySettings.isNewEntitiesPages ? <div className={className}>
      <WebsiteModulePageMetaData controller={controller}/>
      <Router {...routerProps}/>
    </div> : <ScrollerWrapper {...contentProps}>
      <WebsiteModulePageMetaData controller={controller}/>
      <Router {...routerProps}/>
    </ScrollerWrapper>

  );
});
